<template>  
 <v-layout column >
    <v-toolbar class="header-list">
      <v-spacer/>
      <!-- <fleet-filter-icon />       -->
    </v-toolbar>    
    <!-- <fleet-filter />         -->
  </v-layout>
</template>
<script lang="ts" >
  import Vue from 'vue'
  import Component from 'vue-class-component'  
  import FleetFilter from '@/components/fleet/FleetFilter.vue'
  import FleetFilterIcon from '@/components/fleet/FleetFilterIcon.vue'  
  import { FleetUi } from '@/models/ui/FleetUi';
  @Component({
    name: 'FleetDrawerFilter',
      components: {FleetFilter,FleetFilterIcon}      
  })
  export default class FleetDrawerFilter extends Vue {        
    
    get currentDetailFleet(){
      return this.$store.myGetters.currentDetailFleet
    }
    get fleet(){
      return this.currentDetailFleet && this.currentDetailFleet.fleet
    }    
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
